module.exports = __webpack_public_path__ + "files/376ea0db11b5d632b03715a752d804e0.png";